import { createSlice } from '@reduxjs/toolkit';

import { CustomMailState } from 'interfaces/custom-mail';

import { CUSTOM_MAIL_SLICE_NAME } from './action';
import {
  customMailSendingReducer,
  getCountriesReducer,
  getCustomMailRecipientsReducer,
  getCustomMailSentReducer,
  getCustomMailTemplateReducer,
  getCustomMailTypesReducer,
  getCustomMailUsersReducer,
  getEntitiesReducer,
} from './reducers';

export const initialState: CustomMailState = {
  types: {
    options: [],
    isLoading: false,
  },
  entities: {
    options: [],
    isLoading: false,
  },
  template: {
    content: '',
    preview: '',
  },
  entityMembersList: {
    list: null,
    isLoading: false,
    total: 0,
    totalPages: 0,
  },
  usersList: {
    list: null,
    isLoading: false,
    total: 0,
    totalPages: 0,
  },
  mailSend: {
    body: '',
    ids: [],
    type: '',
    entity: '',
    subject: '',
  },
  countryList: {
    list: [],
    isLoading: false,
  },
  sentList: {
    list: null,
    isLoading: false,
    total: 0,
    totalPages: 0,
  },
  isLoading: false,
};

const customMailSlice = createSlice({
  name: CUSTOM_MAIL_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getCustomMailTypesReducer(builder);
    getEntitiesReducer(builder);
    getCustomMailTemplateReducer(builder);
    getCustomMailRecipientsReducer(builder);
    getCustomMailUsersReducer(builder);
    customMailSendingReducer(builder);
    getCountriesReducer(builder);
    getCustomMailSentReducer(builder);
  },
});
export const customMailReducer = customMailSlice.reducer;
